import Icon from '../components/Icon.vue'

Icon.register({"less-than-equal":{"width":448,"height":512,"paths":[{"d":"M55 214.2L356.4 334.1C374.8 340.1 395.1 331.5 401.8 314.9L413.9 284.8C420.5 268.2 411 249.9 392.7 243.8L217.2 175.8 392.8 107.7C411.1 101.7 420.5 83.4 413.9 66.9L401.8 37C395.2 20.5 375 11.9 356.7 17.9L55 137.9C41.2 142.4 32 154.5 32 168.1V184C32 197.6 41.2 209.7 55 214.2zM424 400H24C10.8 400 0 410.7 0 424V472C0 485.3 10.8 496 24 496H424C437.3 496 448 485.3 448 472V424C448 410.7 437.3 400 424 400z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/less-than-equal.js
// module id = hko8
// module chunks = 0